<script lang="ts">
  import NumberRoller from '$lib/components/NumberRoller.svelte'
  import StatsScroller from './StatsScroller.svelte'
  import { deferVideo } from '$lib/attachments/deferVideo'

  export let dollarSign = false
  export let title: string = ''
  export let totalAmount: number | string
  export let videoPath: string = ''
  export let videoContainerStyles: string = ''
  export let videoStyles: string = ''
  export let scrollerLabel: string | null = null
</script>

<li class="relative overflow-hidden">
  <div
    class="relative z-[1] flex w-full flex-col items-center justify-center space-y-4 border-t border-steel py-10 sm-tablet:h-[250px] sm-tablet:border-b lg:h-[362px]"
  >
    <h2
      class="mt-4 text-center font-cirka text-[50px] font-normal leading-[44px] sm-tablet:text-[7vw] sm-desktop:text-[110px]"
    >
      {#if typeof totalAmount === 'string'}
        {totalAmount}
      {:else}
        <NumberRoller value={totalAmount} {dollarSign} />
      {/if}
    </h2>

    <p
      class="font-graphik text-[20px] sm-tablet:absolute sm-tablet:bottom-2 sm-tablet:text-[2vw] sm-desktop:hidden sm-desktop:text-[26px] sm-desktop:font-light"
    >
      {title}
    </p>

    {#if scrollerLabel}
      <div class="hidden lg-desktop:block">
        <StatsScroller label={scrollerLabel} />
      </div>
    {/if}
  </div>
  {#if videoPath}
    <div class="{videoContainerStyles} absolute hidden lg-desktop:block" style="pointer-events: none;">
      <video
        {@attach deferVideo({ media: '(min-width: 1440px)' })}
        autoplay
        data-src={videoPath}
        class="relative {videoStyles}"
        playsinline
        loop
        muted
        defaultMuted
        disableremoteplayback
        oncontextmenu={(event) => event.preventDefault()}
        preload="none"
      >
      </video>
    </div>
  {/if}
</li>
